import React, { Component } from 'react';
import Card from '../../../components/CardNew/index';
import { MUNDIALSOCCERMATCHER, URLRIBBONMATCHES } from '../../../components/RibbonNew/constants';
import GeneralRibbonUtils from '../../../components/RibbonNew/GeneralRibbonUtils';
import Utils from '../../../utils/Utils';
import { CARRUSELESINICIO } from '../../utls/constants';

import './_styles.scss';
export default class RibbonMatcher extends Component {
  constructor(props) {
    super(props);
    this.carruselTitle = props.carruselTitle;
    this.items = props.items;
    this.badgesUserType = props.badgesUserType;
    this.ignoreSeenLast = props.ignoreSeenLast;
    this.focusSettings = props.focusSettings;
    this.ribbonId = props.ribbonId;
    this.focusHandler = props.focusHandler;
    this.onClickHandler = props.onClickHandler;
    this.setMetricsEvent = props.setMetricsEvent;
    this.hideInnerTitle = props.hideInnerTitle;
    this.keyDownHandler = props.keyDownHandler;
    this.className = props.className;
    this.title = props.title;
    this.ribbonIndex = props.index;
    this.typeRender = props.typeRender ? props.typeRender : null;
    this.dataUpdateMetrics = props.dataUpdateMetrics;
    this.visibleItems = props.visibleItems;
    this.ribbonName = props.ribbonName;
  }

  clickHandler(data) {
    this.onClickHandler && this.onClickHandler(data);
  }

  async componentDidMount() {
    window.SpatialNavigation.makeFocusable();
  }

  componentDidUpdate() {
    window.SpatialNavigation.makeFocusable();
  }

  handleOnClick(node_item){
   Utils.sendMetric(this.props, this.props.carruselTitle,  `${node_item.homeParticipant.names.default} vs ${node_item.awayParticipant.names.default}`, CARRUSELESINICIO);
  }

  render() {
    return (
      <div className="ribbon-items ribbon-matches">
        {this.visibleItems.map((node, index) => {
          const node_item = node.item;
          const key = Math.random() * 10;
          const uri = `${URLRIBBONMATCHES}${node_item.id}`;
          const dataMetricsRibbon = {
            node_item,
            node_location: `${URLRIBBONMATCHES}${node_item.id}`,
            ribbon_title: this.carruselTitle,
          };

          let cardProps = {
              unFocusHandler: this.unFocusHandler,
              id: node_item.id,
              key: key,
              ribbonIndex: this.ribbonIndex,
              ignoreSeenLast: this.ignoreSeenLast,
              data: node_item,
              group_id: node_item.id,
              type: MUNDIALSOCCERMATCHER,
              typeRender: '',
              dataMetric: {
                carruselTitle: this.carruselTitle,
                cardPosition: GeneralRibbonUtils.getPositionMundial(
                  this.items,
                  node_item.id
                ),
              },
              focusable: index === 0,
              focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
              focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
              focusHandler: this.focusHandler,
              setMetricsEvent: this.setMetricsEvent,
              href: uri,
              hideInnerTitle: this.hideInnerTitle,
              ribbonName :this.ribbonName, 
              onClick: () => { 
                this.handleOnClick(node_item);
                this.dataUpdateMetrics(dataMetricsRibbon);
              }
          };
          return <Card {...cardProps} />;
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/RibbonMatchers/index.jsx